import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
import _imports_0 from '../../../assets/map/113693/gohome.png';
import _imports_1 from '../../../assets/map/113693/listmenu.png';
import _imports_2 from '../../../assets/map/113693/desc.png';
const _hoisted_1 = {
  class: "tgxmapContainer"
};
const _hoisted_2 = {
  class: "rightTopWrap"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "popWrap"
};
const _hoisted_5 = {
  class: "innerWrap"
};
const _hoisted_6 = {
  class: "searchbox"
};
const _hoisted_7 = {
  class: "innercontent"
};
const _hoisted_8 = {
  class: "ulwrap"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  href: "javascript:void(0)"
};
const _hoisted_11 = {
  class: "imgbox"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "txtbox"
};
const _hoisted_14 = {
  class: "nodata"
};
const _hoisted_15 = {
  class: "popWrap descwrap"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mapassembly = _resolveComponent("mapassembly");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: _normalizeClass(["itemWrap", {
      'style2': $data.formUserId !== '747871783' && $data.formUserId !== '842035648'
    }])
  }, [_withDirectives(_createElementVNode("div", {
    class: "itembox1 style2",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goHome && $options.goHome(...args))
  }, [...(_cache[8] || (_cache[8] = [_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1), _createElementVNode("p", null, "首页", -1)]))], 512), [[_vShow, $data.formUserId !== '747871783' && $data.formUserId !== '842035648']]), _withDirectives(_createElementVNode("div", {
    class: "itembox1 style2",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.showList && $options.showList(...args))
  }, [...(_cache[9] || (_cache[9] = [_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }, null, -1), _createElementVNode("p", null, "文物列表", -1)]))], 512), [[_vShow, $data.formUserId !== '747871783']]), _withDirectives(_createElementVNode("div", {
    class: "itembox1 style2",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.descList && $options.descList(...args))
  }, [...(_cache[10] || (_cache[10] = [_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }, null, -1), _createElementVNode("p", null, "文物介绍", -1)]))], 512), [[_vShow, $data.formUserId !== '747871783']])], 2), $data.formUserId === '747871783' || $data.formUserId === '842035648' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "itembox1",
    onClick: _cache[3] || (_cache[3] = $event => $options.goLink($data.linkdata.link))
  }, [_createElementVNode("img", {
    src: $data.linkdata.img,
    alt: ""
  }, null, 8, _hoisted_3), _createElementVNode("p", null, _toDisplayString($data.formUserId === '842035648' ? '铜鼓县文博地图' : '不可移动革命文物地图'), 1)])) : _createCommentVNode("", true)]), _withDirectives(_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "bg",
    onClick: _cache[4] || (_cache[4] = $event => $data.listFlag = false)
  }), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("input", {
    type: "text",
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.searchKey = $event),
    placeholder: "请输入搜索内容"
  }, null, 512), [[_vModelText, $data.searchKey]]), _createElementVNode("span", {
    class: "icon-search",
    onClick: _cache[6] || (_cache[6] = (...args) => $options.gosearch && $options.gosearch(...args))
  })]), _createElementVNode("div", _hoisted_7, [_createElementVNode("ul", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dataList, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      onClick: $event => $options.ItemHandle(item)
    }, [_createElementVNode("a", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
      src: item.itemformdata.image,
      alt: ""
    }, null, 8, _hoisted_12)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("h2", null, _toDisplayString(item.itemformdata.placeName), 1), _withDirectives(_createElementVNode("p", null, "类型：" + _toDisplayString(item.itemformdata[55]), 513), [[_vShow, item.itemformdata[55] !== '']]), _withDirectives(_createElementVNode("p", null, "地址：" + _toDisplayString(item.itemformdata.address), 513), [[_vShow, item.itemformdata.address !== '']])])])], 8, _hoisted_9);
  }), 128))]), _withDirectives(_createElementVNode("div", _hoisted_14, "暂无数据", 512), [[_vShow, $data.nodataFlag]])])])], 512), [[_vShow, $data.listFlag]]), _withDirectives(_createElementVNode("div", _hoisted_15, [_createElementVNode("div", {
    class: "bg",
    onClick: _cache[7] || (_cache[7] = $event => $data.descFlag = false)
  }), _cache[11] || (_cache[11] = _createElementVNode("div", {
    class: "innerWrap"
  }, [_createElementVNode("div", {
    class: "innercontent"
  }, [_createElementVNode("div", {
    class: "descbox"
  }, [_createElementVNode("div", {
    class: "richtext",
    id: "editor1"
  })])])], -1))], 512), [[_vShow, $data.descFlag]]), _createVNode(_component_mapassembly, {
    id: 1,
    ref: `map`,
    mapconfigdatas: $data.mapconfigdatas,
    onCloseHandle: $options.closeHandle
  }, null, 8, ["mapconfigdatas", "onCloseHandle"])]);
}